import * as React from 'react';
import { Component } from 'react';
import './ClinicCombo.css';
import { IClinicListItem } from '../models/IClinicListItem';


interface IProps {
    Clinics: IClinicListItem[],
    SelectedClinic?: IClinicListItem,
    OnClinicSelected: (clinic: IClinicListItem) => void
}

interface IState {
    ShowDropDown: boolean
}

export class ClinicComboComponent extends Component<IProps, IState> {

    private DropDownContainerNode: Node | null;
    private SelectedElementNode: Node | null;

    constructor(props) {
        super(props);

        this.state = {
            ShowDropDown: false
        }

        this.ToggleDropDown = this.ToggleDropDown.bind(this);
        this.HandleClickOutside = this.HandleClickOutside.bind(this);
    }

    public componentWillMount() {
        document.addEventListener('click', this.HandleClickOutside, false);
    }

    public componentWillUnmount() {
        document.removeEventListener('click', this.HandleClickOutside, false);
    }

    public render() {
        return (
            <div className="clinic-combo-component" ref={node => this.DropDownContainerNode = node}>
                {this.RenderDropDownButton()}
                {this.RenderSelectedItem()}
                {this.RenderDropDown()}
            </div>
        );
    }

    private RenderSelectedItem() {
        return (
            <div className="selected-item clinic-item"
                onClick={this.ToggleDropDown}
                ref={node => this.SelectedElementNode = node}>
                <span className="name">{this.props.SelectedClinic ? this.props.SelectedClinic.FullName : null}</span>
                <span className="address">{ this.props.SelectedClinic ? this.props.SelectedClinic.FullAddress : null }</span>
            </div>
        );
    }

    private RenderDropDownButton() {
        return (
            <div className="drop-down-button">
                &nbsp;
            </div>
        );
    }

    private RenderDropDown() {
        if (this.state.ShowDropDown) {
            let items = this.props.Clinics.map((clinic) => (
                <li key={clinic.Id} onClick={this.OnClinicSelected.bind(this, clinic)}>
                    <div className="clinic-item">
                        <span className="name">{clinic.FullName}</span>
                        <span className="address">{clinic.FullAddress}</span>
                    </div>
                </li>
            ));

            return (
                <div className="drop-down-container">
                    <ul>
                        {items}
                    </ul>
                </div>
            );
        } else {
            return null;
        }
    }

    private HandleClickOutside(e: MouseEvent) {
        if (this.DropDownContainerNode !== null) {
            if (this.DropDownContainerNode.contains(e.target as HTMLElement)) {
                if (this.SelectedElementNode !== null) {
                    if (this.SelectedElementNode.contains(e.target as HTMLElement)) {
                        return;
                    }
                }
                this.setState({
                    ShowDropDown: true
                });
            } else {
                this.setState({
                    ShowDropDown: false
                });
            }
        }
    }

    private ToggleDropDown(evt) {
        this.setState({
            ShowDropDown: !this.state.ShowDropDown
        });
        evt.stopPropagation();
    }

    private OnClinicSelected(selectedClinic: IClinicListItem, evt) {
        this.setState({
            ShowDropDown: false
        });
        this.props.OnClinicSelected(selectedClinic);
    }
}


// WEBPACK FOOTER //
// ./src/controls/ClinicCombo.tsx